import {useEffect, useState} from 'react';

/** Body classes from CMS blog `pageType` (same set as blog global styles in `blog-page-global.js`). */
const BLOG_ARTICLE_BODY_CLASSES = [
  'page--blog-page',
  'page--blog-editorial-listing',
  'page--blog-article-img',
  'page--blog-article-content',
];

const isBlogArticleLayoutBody =
  typeof document === 'undefined'
    ? () => false
    : () => BLOG_ARTICLE_BODY_CLASSES.some((cls) => document.body?.classList?.contains(cls));

/**
 * True when blog article layout is active (`page--blog-*` on `document.body` from useBodyPageType).
 * Used to scope Contentful Video overlay chrome (blog-only).
 */
export const useBlogArticleVideoChrome = () => {
  const [active, setActive] = useState(() => isBlogArticleLayoutBody());

  useEffect(() => {
    const read = () => isBlogArticleLayoutBody();

    setActive(read());

    const observer = new MutationObserver(() => setActive(read()));
    observer.observe(document.body, {attributes: true, attributeFilter: ['class']});

    return () => observer.disconnect();
  }, []);

  return active;
};
